import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabase } from "@/lib/supabase";

export const Route = createFileRoute("/p/$postId")({
  beforeLoad: async ({ params }) => {
    const { postId } = params;

    // Look up the post's club_id to redirect to the canonical URL
    const { data: post } = await supabase
      .from("posts")
      .select("club_id")
      .eq("id", postId)
      .single();

    if (post?.club_id) {
      throw redirect({
        to: "/clubs/$clubId/posts/$postId",
        params: { clubId: post.club_id, postId },
      });
    }

    // If post not found, continue to render the component (shows error)
  },
  component: PostNotFound,
});

function PostNotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-6">
      <h2 className="text-xl font-medium text-text-primary mb-2">
        Post not found
      </h2>
      <p className="text-text-secondary text-center mb-6">
        The post you are looking for does not exist or has been removed.
      </p>
    </div>
  );
}
